// extracted by mini-css-extract-plugin
export default {"courseIcon":"CourseIcon_courseIcon__X0ObL"};